import { createSlice } from "@reduxjs/toolkit";

// Enum for offer data sections
export const OfferDataSection = {
  START_DATE: "START_DATE",
  PRICE_PROPOSAL: "PRICE_PROPOSAL",
  TITLE: "TITLE",
  CONDITION_DESCRIPTION: "CONDITION_DESCRIPTION",
  SCOPE_OF_DELIVERY: "SCOPE_OF_DELIVERY",
  NULL: "NULL",
};

// Initial state
const initialState = {
  currentOfferDataSection: OfferDataSection.NULL,
  hideScopeOfDeliveryEditOption: false,
};

// Create the slice
const offerDataSlice = createSlice({
  name: "offerData",
  initialState,
  reducers: {
    setCurrentOfferDataSection: (state, action) => {
      state.currentOfferDataSection = action.payload;
    },
    resetOfferDataSection: (state) => {
      state.currentOfferDataSection = OfferDataSection.NULL;
    },
    setHideScopeOfDeliveryEditOption: (state, action) => {
      state.hideScopeOfDeliveryEditOption = action.payload;
    },
  },
});

// Export actions
export const {
  setCurrentOfferDataSection,
  resetOfferDataSection,
  setHideScopeOfDeliveryEditOption,
} = offerDataSlice.actions;

// Export reducer
export default offerDataSlice.reducer;

// Selectors
export const selectCurrentOfferDataSection = (state) =>
  state.offerData.currentOfferDataSection;
export const selectHideScopeOfDeliveryEditOption = (state) =>
  state.offerData.hideScopeOfDeliveryEditOption;
